document.addEventListener('DOMContentLoaded', function() {
  function preventGallerySwipe() {
    const dayNightSliders = document.querySelectorAll('.day-night-media .progressfader');
    
    if (dayNightSliders.length > 0) {
      dayNightSliders.forEach(slider => {
        const controls = slider.querySelector('.controls');
        const track = slider.querySelector('.slider-track');
        const handle = slider.querySelector('.slider-handle');
        
        if (controls) {
          controls.addEventListener('touchstart', stopPropagation, { passive: false });
          controls.addEventListener('touchmove', stopPropagation, { passive: false });
          controls.addEventListener('click', stopPropagation, { passive: false });
          
          if (track) {
            track.addEventListener('touchstart', stopPropagation, { passive: false });
            track.addEventListener('touchmove', stopPropagation, { passive: false });
            track.addEventListener('click', stopPropagation, { passive: false });
          }
          
          if (handle) {
            handle.addEventListener('touchstart', stopPropagation, { passive: false });
            handle.addEventListener('touchmove', stopPropagation, { passive: false });
            handle.addEventListener('click', stopPropagation, { passive: false });
          }
        }
      });
    }
  }
  
  function stopPropagation(e) {
    e.stopPropagation();
  }
  
  preventGallerySwipe();
  
  setTimeout(preventGallerySwipe, 1000);
});